import { render } from "./DrawerPage.vue?vue&type=template&id=35369775&scoped=true"
import script from "./DrawerPage.vue?vue&type=script&lang=js"
export * from "./DrawerPage.vue?vue&type=script&lang=js"

import "./DrawerPage.vue?vue&type=style&index=0&id=35369775&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35369775"]])

export default __exports__